import { c as _c } from "react/compiler-runtime";
export const IconColors = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M348-138 98-388q-9-9.12-13.5-20.06T80-430.7q0-11.7 4.5-22.5T98-473l250-250-93-93q-9-9-9-21t9-21q9-9 21.42-9 12.43 0 21.58 9l385 385q9.47 9 13.74 19.8 4.26 10.8 4.26 22.5t-4.26 22.64Q692.47-397.12 683-388L433-138q-9 9-19.8 13.5t-22.5 4.5q-11.7 0-22.64-4.5Q357.12-129 348-138Zm43-542L141-430h500L391-680Zm408.66 560q-33.35 0-56.5-23.18Q720-166.36 720-200q0-26.28 10-49.64T756-293l26-34q7-9 18-9t18 9l26 34q15 20 25.5 43.36T880-200q0 33.64-23.5 56.82T799.66-120Z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
IconColors.displayName = 'IconColors';